export default __webpack_public_path__ + "static/media/S1xCLUE1.7a79f48c.jpg";